import '../kickstart';
import AudioPlayer from '../audio-player';

const VISIBLE_CLASS = 'full-bleed--visible';

const imageObserver = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      const { target } = entry;

      if (entry.isIntersecting) {
        target.classList.add(VISIBLE_CLASS);
      } else {
        target.classList.remove(VISIBLE_CLASS);
      }
    });
  },
  {
    rootMargin: '-12% 0%',
  }
);

const player = new AudioPlayer({ template: 'assets/audio/{{slug}}.{{ext}}' });

const introClip = document.querySelector('#intro-clip');
const introSrc = introClip.getAttribute('data-audio-src');

const introPlayButton = introClip.querySelector('.js-play-button');
const introPauseButton = introClip.querySelector('.js-pause-button');

introPlayButton.addEventListener('click', () => {
  player.play(introSrc);
});

introPauseButton.addEventListener('click', () => {
  player.stop(introSrc);
});

player.on('play', ({ slug }) => {
  if (introSrc === slug) {
    introPlayButton.classList.add('display-none');
    introPauseButton.classList.remove('display-none');
  }
});

player.on('ended', ({ slug }) => {
  if (introSrc === slug) {
    introPlayButton.classList.remove('display-none');
    introPauseButton.classList.add('display-none');
  }
});

player.on('stop', ({ slug }) => {
  if (introSrc === slug) {
    introPlayButton.classList.remove('display-none');
    introPauseButton.classList.add('display-none');
  }
});

const audioObserver = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      const { target } = entry;
      const src = target.getAttribute('data-audio-src');

      if (!src) return;

      if (entry.isIntersecting) {
        player.play(src);
      } else {
        player.stop(src);
      }
    });
  },
  {
    rootMargin: '-50% 0%',
  }
);

const preloadObserver = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      const { target } = entry;
      const src = target.getAttribute('data-audio-src');

      if (!src) return;

      if (entry.isIntersecting) {
        player.load(src);
      }
    });
  },
  {
    rootMargin: '300px 0px',
  }
);

const cells = document.querySelectorAll('.js-audio-cell');

for (let index = 0; index < cells.length; index++) {
  const element = cells[index];
  // const elementToObserve = element.querySelector('.full-bleed-header__title');
  const src = element.getAttribute('data-audio-src');
  const playButton = element.querySelector('.js-play-button');
  const pauseButton = element.querySelector('.js-pause-button');

  playButton.addEventListener('click', () => {
    player.play(src);
  });

  pauseButton.addEventListener('click', () => {
    player.stop(src);
  });

  player.on('play', ({ slug }) => {
    if (src === slug) {
      playButton.classList.add('display-none');
      pauseButton.classList.remove('display-none');
    }
  });

  player.on('ended', ({ slug }) => {
    if (src === slug) {
      playButton.classList.remove('display-none');
      pauseButton.classList.add('display-none');
    }
  });

  player.on('stop', ({ slug }) => {
    if (src === slug) {
      playButton.classList.remove('display-none');
      pauseButton.classList.add('display-none');
    }
  });

  audioObserver.observe(element);
  preloadObserver.observe(element);
  imageObserver.observe(element);
}
